import React from 'react';
import { lazy } from 'react';

export const defaultJwtUserInfo = JSON.stringify({
    FirstName: '',
    LastName: '',
    FullName: '',
});

export const APP_NAMES = Object.freeze({
    MANAGER: 'manager',
    EMPLOYEE: 'employee',
    ADMIN: 'admin',
});

/**
 * @param {CommonClient2.AppNames | undefined} appName
 */
export const getAppSidebar = (appName) => {
    const empty = () => <></>;
    switch (appName) {
        case APP_NAMES.MANAGER:
            return lazy(() => import('../SidebarManager'));
        default:
            return empty;
    }
};
